import { render, staticRenderFns } from "./DisposeLabManager.vue?vue&type=template&id=19e3f656"
import script from "./DisposeLabManager.vue?vue&type=script&lang=js"
export * from "./DisposeLabManager.vue?vue&type=script&lang=js"
import style0 from "./DisposeLabManager.vue?vue&type=style&index=0&id=19e3f656&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports